import React, { useEffect, useState } from "react";
import { Button, Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

/**
 * Stripe redirects here after confirmPayment. The query string carries
 * redirect_status; we surface it and clear the cart on success.
 */
export default function OrderConfirmation() {
  const navigate = useNavigate();
  const [status, setStatus] = useState<string | null>(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const redirectStatus = params.get("redirect_status");
    setStatus(redirectStatus);
    if (redirectStatus === "succeeded") {
      localStorage.removeItem("cartItems");
    }
  }, []);

  const succeeded = status === "succeeded";

  return (
    <Container className="py-5 text-center">
      <h2 className="fw-bold mb-3">
        {succeeded ? "Thank you for your order!" : "Payment status"}
      </h2>
      <p className="text-muted">
        {succeeded
          ? "Your payment was successful. A receipt has been emailed to you."
          : status === "processing"
          ? "Your payment is processing. We'll email you when it completes."
          : "We couldn't confirm your payment. If you were charged, please contact us."}
      </p>
      <Button className="btn btn-primary mt-3" onClick={() => navigate("/store")}>
        Continue shopping
      </Button>
    </Container>
  );
}
